import { ReactNode } from "react"

type FieldProps = {
  label: string
  htmlFor: string
  children: ReactNode
}

const Field = ({ label, htmlFor, children }: FieldProps) => (
  <div className="flex flex-col gap-2">
    <label
      htmlFor={htmlFor}
      className="text-xs tracking-[-0.01em] text-[#9CA3AF]"
    >
      {label}
    </label>
    {children}
  </div>
)

export default Field
